import { render, staticRenderFns } from "./NavTabPanes.vue?vue&type=template&id=b7c09f22&"
import script from "./NavTabPanes.vue?vue&type=script&lang=js&"
export * from "./NavTabPanes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports